<template>
  <VDialogV3
    id="cargo-units-summary-dialog"
    :entity="transportOrder"
    width="550px"
    title="Груз"
    :tabs="tabs"
    v-model:active-tab="activeTab"
  >
    <template v-if="activeTab.id === 'cargoUnits'">
      <section>
        <div class="cargo-unit" v-if="totalQty.greaterThan(Qty.fromServer(1))">
          <dl>
            <dt>Состав груза</dt>
            <dd>Несколько мест</dd>
          </dl>

          <div class="cargo-unit-inputs">
            <VInputNumberRusV2
              disabled
              :model-value="maxValues.maxLength"
              unit="мм"
              :type="Dimension"
              label="Самое длинное место"
            />

            <VInputNumberRusV2
              disabled
              :model-value="maxValues.maxWidth"
              unit="мм"
              :type="Dimension"
              label="Самое широкое место"
            />

            <VInputNumberRusV2
              disabled
              :model-value="maxValues.maxHeight"
              unit="мм"
              :type="Dimension"
              label="Самое высокое место"
            />

            <VInputNumberRusV2
              disabled
              :model-value="maxValues.maxWeightGross"
              unit="кг"
              :type="Weight"
              label="Самое тяжелое место"
            />

            <VInputNumberRusV2
              disabled
              :model-value="totalQty"
              unit="шт"
              :type="Qty"
              label="Количество мест"
            />

            <VInputNumberRusV2
              disabled
              :model-value="totalWeight"
              unit="кг"
              :type="Weight"
              label="Общий вес"
            />

            <VInputNumberRusV2
              disabled
              :model-value="totalVolume"
              unit="м3"
              :type="Volume"
              label="Общий объём"
            />
          </div>
        </div>
        <div class="cargo-unit" v-if="totalQty.equals(Qty.fromServer(1))">
          <dl>
            <dt>Состав груза</dt>
            <dd>1 место</dd>
          </dl>

          <div class="cargo-unit-inputs">
            <div class="cargo-dimensions">
              <VInput
                disabled
                :value="`${ maxValues.maxLength } х ${ maxValues.maxWidth } x ${ maxValues.maxHeight }`"
                unit="мм"
                label="Габариты груза"
              />

              <VLink
                material="info"
                @mouseenter="$core.tooltip.show(
              $event.currentTarget,
             `Длина: ${ maxValues.maxLength }; Ширина: ${ maxValues.maxWidth }; Высота: ${ maxValues.maxHeight }`
            )"
                @mouseleave="$core.tooltip.hide()"
              >
                Подробнее
              </VLink>
            </div>

            <VInputNumberRusV2
              disabled
              :model-value="totalWeight"
              unit="кг"
              :type="Weight"
              label="Вес груза"
            />

            <VInputNumberRusV2
              disabled
              :model-value="totalVolume"
              unit="м3"
              :type="Volume"
              label="Объём груза"
            />
          </div>
        </div>

        <template v-if="totalQty.isZero()">
          <div class="empty">
            Нет палет
          </div>
        </template>
      </section>
    </template>

    <template v-if="activeTab.id === 'partners'">
      <section>
        <dl>
          <dt>Грузоотправитель</dt>
          <dd>
            <CompanyDetail
              v-if="transportOrder.senderCompany && transportOrder.senderStore"
              :company="transportOrder.senderCompany"
              :store="transportOrder.senderStore"
            />
            <template v-else>Не найдена</template>
          </dd>

          <dt>Грузополучатель</dt>
          <dd>
            <CompanyDetail
              v-if="transportOrder.receiverCompany && transportOrder.receiverStore"
              :company="transportOrder.receiverCompany"
              :store="transportOrder.receiverStore"
            />
            <template v-else>Не найдена</template>
          </dd>
        </dl>
      </section>
    </template>

    <template #footer>
      <footer>
        <VButton @click="closeDialog">Отмена</VButton>
      </footer>
    </template>
  </VDialogV3>
</template>

<style lang="scss" src="./CargoUnitsSummaryDialog.scss"/>

<script lang="ts">

import CompanyDetail from '@/domains/Companies/components/CompanyDetail/CompanyDetail';

import TransportOrder from '@/domains/TransportOrders/TransportOrder';
import Dimension from "@/core/types/Dimension";
import Volume from "@/core/types/Volume";
import Weight from "@/core/types/Weight";
import Qty from "@/core/types/Qty";

export default defineComponent({
  name: 'CargoUnitsSummaryDialog',

  components: {
    CompanyDetail,
  },

  props: {
    transportOrder: {
      type: TransportOrder,
      default: null,
      required: true,
    },
  },

  setup() {
    return {
      Volume,
      Dimension,
      Weight,
      Qty
    }
  },

  data() {
    return {
      tabs: [
        {
          name: 'Контрагент',
          id: 'partners',
        },
        {
          name: 'ВГХ',
          id: 'cargoUnits',
        },
      ],
      activeTab: {
        name: 'Контрагент',
        id: 'partners',
      },
      popup: {
        visible: false,
        target: null,
      },
    };
  },

  computed: {
    maxValues() {
      let maxWeightGross = Weight.fromServer(0),
        maxLength = Dimension.fromServer(0),
        maxWidth = Dimension.fromServer(0),
        maxHeight = Dimension.fromServer(0);

      this.transportOrder.cargoUnits.items.forEach(unit => {
        if (unit.weightGross?.greaterThan(maxWeightGross)) {
          maxWeightGross = unit.weightGross;
        }

        if (unit.length?.greaterThan(maxLength)) {
          maxLength = unit.length;
        }

        if (unit.width?.greaterThan(maxWidth)) {
          maxWidth = unit.width;
        }

        if (unit.height?.greaterThan(maxHeight)) {
          maxHeight = unit.height;
        }
      });

      return {
        maxWeightGross,
        maxLength,
        maxWidth,
        maxHeight,
      };
    },
    totalQty() {
      return this.transportOrder.cargoUnitsCount;
    },
    totalWeight() {
      return this.transportOrder.cargoWeightGross;
    },
    totalVolume() {
      return this.transportOrder.cargoVolume;
    },

  },

  methods: {
    setActiveTab(tab) {
      if (this.activeTab.id !== tab.id) {
        this.activeTab = tab;
      }
    },

    closeDialog() {
      this.$core.dialogs.CargoUnitsSummaryDialog.hide();
    }
  },

});
</script>

